module.exports = __webpack_public_path__ + "static/media/mandate_pending_icon.dd823a20.svg";